import React from 'react';
import { Link } from 'react-router-dom';
import { Send, Mail, MapPin, Shield, Truck, CreditCard } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-b from-white to-blue-50 border-t border-blue-100 mt-20">
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-10">
          <div className="col-span-2">
            <div className="flex items-center gap-2 mb-3">
              <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-blue-600 to-sky-400 flex items-center justify-center">
                <span className="text-white font-bold text-lg">α</span>
              </div>
              <div>
                <div className="text-slate-900 font-bold text-lg">AlphaPro Genetics</div>
                <div className="text-blue-600 text-[10px] font-semibold uppercase tracking-widest">Pharmaceutical Grade</div>
              </div>
            </div>
            <p className="text-sm text-slate-600 leading-relaxed max-w-md">
              Najlepszy w Polsce sklep z anabolikami, peptydami i suplementami. Sprawdzone laboratoria, oryginalne produkty i pełna dyskrecja od 2021 roku.
            </p>
            <a href="https://t.me/+9A5CpRihCfNjMzc0" target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 mt-4 px-5 py-2.5 rounded-full bg-blue-600 hover:bg-blue-700 text-white text-sm font-semibold shadow-lg shadow-blue-200 transition">
              <Send className="w-4 h-4" /> Telegram
            </a>
          </div>

          <div>
            <h4 className="text-slate-900 font-semibold mb-3 text-sm">Sklep</h4>
            <ul className="space-y-2 text-sm text-slate-600">
              <li><Link to="/sklep?cat=inj" className="hover:text-blue-600">Sterydy iniekcyjne</Link></li>
              <li><Link to="/sklep?cat=tab" className="hover:text-blue-600">Sterydy tabletkowe</Link></li>
              <li><Link to="/sklep?cat=pep" className="hover:text-blue-600">Peptydy & HGH</Link></li>
              <li><Link to="/sklep?cat=sup" className="hover:text-blue-600">Suplementy & PCT</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-slate-900 font-semibold mb-3 text-sm">Informacje</h4>
            <ul className="space-y-2 text-sm text-slate-600">
              <li><Link to="/o-nas" className="hover:text-blue-600">O nas</Link></li>
              <li><Link to="/kontakt" className="hover:text-blue-600">Kontakt</Link></li>
              <li><a href="#" className="hover:text-blue-600">Polityka prywatności</a></li>
              <li><a href="#" className="hover:text-blue-600">Regulamin</a></li>
            </ul>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 py-6 border-t border-b border-blue-100">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center"><Shield className="w-5 h-5 text-blue-600" /></div>
            <div>
              <div className="text-sm font-semibold text-slate-900">100% Anonimowość</div>
              <div className="text-xs text-slate-500">Kontakt przez Telegram</div>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center"><Truck className="w-5 h-5 text-blue-600" /></div>
            <div>
              <div className="text-sm font-semibold text-slate-900">Szybka wysyłka</div>
              <div className="text-xs text-slate-500">24-48h po zapłacie</div>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center"><CreditCard className="w-5 h-5 text-blue-600" /></div>
            <div>
              <div className="text-sm font-semibold text-slate-900">Bezpieczne płatności</div>
              <div className="text-xs text-slate-500">BLIK / Przelew / Krypto</div>
            </div>
          </div>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-between gap-2 pt-6">
          <p className="text-xs text-slate-500">© 2026 AlphaPro Genetics. Wszelkie prawa zastrzeżone.</p>
          <div className="flex items-center gap-4 text-xs text-slate-500">
            <span className="inline-flex items-center gap-1"><Mail className="w-3.5 h-3.5" /> kontakt@alphapro-genetics.pl</span>
            <span className="inline-flex items-center gap-1"><MapPin className="w-3.5 h-3.5" /> Warszawa, Polska</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
